// extracted by mini-css-extract-plugin
export var base = "Header-module--base--5bc47";
export var fixed = "Header-module--fixed--931d8";
export var menuContainer = "Header-module--menu-container--1fe74";
export var sticky = "Header-module--sticky--c547d";